import React, { useEffect } from 'react';
import { InsuranceCompanyData } from '@/common/types';
import { useBadgeMultiSelect } from '@/portal/hooks/useBadgeMultiSelect.ts';
import BadgeMultiSelect from '@/portal/components/BadgeMultiSelect.tsx';
import { loadInsuranceCompanies } from '@/common/api';

interface InsuranceMultiSelectProps {
  selected: InsuranceCompanyData[];
  onChange: (updated: InsuranceCompanyData[]) => void;
}

const InsuranceMultiSelect: React.FC<InsuranceMultiSelectProps> = ({
  selected,
  onChange,
}) => {
  const { allItems, selectedItems, toggleItem, selectAllItems } =
    useBadgeMultiSelect<InsuranceCompanyData>({
      loadAllItems: loadInsuranceCompanies,
      initialSelected: selected,
    });

  useEffect(() => {
    onChange(selectedItems);
  }, [selectedItems, onChange]);

  return (
    <BadgeMultiSelect
      label="Insurance Companies"
      allItems={allItems}
      selectedItems={selectedItems}
      onToggle={toggleItem}
      getId={(badge) => badge.id}
      getLabel={(badge) => badge.name}
      selectAllItems={selectAllItems}
    />
  );
};

export default InsuranceMultiSelect;
